import React from 'react';
import { getAIModelIcon } from '@/lib/get-icon';
import { CalenderIcon } from '@/components/icons/calendar-icon';
import { BriefcaseBusiness, DownloadIcon } from 'lucide-react';
import { EyeIcon } from '@/components/icons/eye-icon';
import { LabelIcon } from '@/components/icons/label-icon';
import { UpdateIcon } from '@/components/icons/update-icon';
import dayjs from 'dayjs';
import AnchorLink from '@/components/ui/links/anchor-link';
import routes from '@/config/routes';

interface ProductMetadataProps {
  product: any;
}

export const ProductMetadata: React.FC<ProductMetadataProps> = ({
  product,
}) => {
  console.log(product);
  return (
    <div className="mt-4 flex flex-wrap items-center justify-between gap-4 border-gray-100 dark:border-gray-800">
      <div className="flex flex-wrap gap-4 text-sm text-gray-500">
        <div className="flex items-center gap-4 text-sm text-gray-500">
          <div className="flex items-center gap-1">
            <div className="flex align-bottom">
              {getAIModelIcon({
                iconName: product.ai_model.slug,
                className: 'h-5 w-5 text-light-base',
              })}
              <p className="font-small content-center pl-2 text-start align-bottom text-light-base dark:text-dark-800">
                <span className="">
                  {product.ai_model.name}
                </span>
              </p>
            </div>
            {product.ai_model_version && (
              <span className="text-xs">({product.ai_model_version.name})</span>
            )}
          </div>
        </div>
        {/* Stats */}
        <div className="flex items-center gap-4 text-sm text-gray-500">
          {product.views_count && (
            <div className="flex items-center gap-1">
              <EyeIcon className="h-4 w-4" />
              <span>{product.views_count} views</span>
            </div>
          )}
          {product.generations_count && product.generations_count > 0 ? (
            <div className="flex items-center gap-1">
              <DownloadIcon className="h-4 w-4" />
              <span>{product.generations_count} generations</span>
            </div>
          ) : null}
        </div>
        {/* Dates */}
        <div className="flex items-center gap-4 text-sm text-gray-500">
          <div className="flex items-center gap-1">
            <CalenderIcon className="h-4 w-4" />
            <span>
              Created {dayjs(product.created_at).format('MMM D, YYYY')}
            </span>
          </div>
          <div className="flex items-center gap-1">
            <UpdateIcon className="h-4 w-4" />
            <span>
              Updated {dayjs(product.updated_at).format('MMM D, YYYY')}
            </span>
          </div>
        </div>
      </div>

      {/* Tags */}
      {product.tags?.length > 0 && (
        <div className="flex items-center gap-2">
          <LabelIcon className="h-4 w-4 text-gray-500" />
          <div className="flex flex-wrap gap-2">
            {product.tags.map((tag: any) => (
              <AnchorLink
                key={tag.id}
                href={routes.tagUrl(tag.slug)}
                className="rounded-full bg-gray-100 px-2 py-1 text-xs hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700"
              >
                {tag.name}
              </AnchorLink>
            ))}
          </div>
        </div>
      )}

      {/* Categories
      {product.categories?.length > 0 && (
        <div className="flex items-center gap-2">
          <BriefcaseBusiness className="h-4 w-4 text-gray-500" />
          <div className="flex flex-wrap gap-2">
            {product.categories.map((category: any, index: number) => (
              <span key={category.id} className="text-sm">
                {category.name}
                {index < product.categories.length - 1 && ', '}
              </span>
            ))}
          </div>
        </div>
      )} */}
    </div>
  );
};
